import(/* webpackMode: "eager" */ "/vercel/path0/src/app/inspections/page.tsx");
